<template>
  <transition name="fade">
    <div class="suspend-btn-list" v-if="isShow">
      <div class="nps" v-if="showNps">
        <div class="show-nps" @click="showNpsDialog = true" aria-label="问卷调查">
          <img
            v-if="isDark"
            src="https://zhanstatic.vivo.com.cn/wukong-zhan/img/40d7272d-e656-4278-9c0c-8f9e5937c080.png"
            aria-hidden="true"
          />
          <img
            v-else
            src="https://zhanstatic.vivo.com.cn/wukong-zhan/img/04d13759-c0e6-4cf9-b952-002bd1665f83nwebp_compress.png"
            aria-hidden="true"
          />
        </div>
        <v-os-popup
          container="body"
          class="nps-popup"
          v-model="showNpsDialog"
          :hideTitle="true"
          :maxHeightFill="true"
          @close="showNpsDialog = false"
          :footerShow="false"
        >
          <div class="nps-wrapper">
            <iframe width="100%" height="100%" :src="nps.npsLink"></iframe>
          </div>
        </v-os-popup>
      </div>

      <div class="back-to-top" aria-label="回到顶部" @click="toTop">
        <img v-if="isDark" src="./img/back-to-top-dark.png" aria-hidden="true" />
        <img v-else src="./img/back-to-top.png" aria-hidden="true" />
      </div>
    </div>
  </transition>
</template>

<script>
import { debounce } from 'utils/common'
import { scrollY } from 'utils/scroll'
import clientEnv from 'utils/clientEnv'
import { app } from '@/utils'
import { mapState, mapGetters } from 'vuex'

const FINISH_NPS = 'finishNps'
export default {
  name: 'SuperposedLayer',
  data() {
    return {
      link: '',
      isShow: false,
      showNpsDialog: false, // 是否展示问卷弹框
      finishNps: localStorage.getItem(FINISH_NPS), // 时间
      isDark: app.getColorScheme()
    }
  },
  mounted() {
    window.addEventListener(
      'scroll',
      debounce(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        this.isShow = scrollTop > 90
      }, 100)
    )
  },
  computed: {
    ...mapState('detailv3', ['skuInfo']),
    ...mapGetters('detailv3', ['discountType', 'isProxySale']),
    nps() {
      return this.skuInfo.npsInfoVo || {}
    },
    // 是否展示nps入口
    showNps() {
      this.link = this.nps.npsLink
      // 判断是不是在android app中
      const isAndroidVivoApp = clientEnv.isAndroid && clientEnv.isVivoApp
      if (isAndroidVivoApp && this.nps.valid && this.typeCheck) {
        // 判断24小时内是否填写过问卷
        if (!this.finishNps || Date.now() - this.finishNps > 24 * 3600 * 1000) {
          return true
        }
      }
      return false
    },
    // nps不支持秒杀、拼团、代销、采销
    typeCheck() {
      if (this.$router.history.current.path.includes('seckill')) {
        // 秒杀
        return false
      } else if (this.discountType === 'group') {
        // 拼团
        return false
      } else if (this.isProxySale) {
        // 采销、代销
        return false
      }
      return true
    }
  },
  destroyed() {
    window.removeEventListener('message', this.onMessage)
  },
  methods: {
    onMessage(ev) {
      if (typeof ev.data === 'string' && ev.origin.includes('.vivo.com.cn')) {
        try {
          const data = JSON.parse(ev.data)

          if (data.dialogStatus === 'close') {
            this.showNpsDialog = false
            // 记录完成问卷调查的时间戳
            this.finishNps = Date.now()
            localStorage.setItem(FINISH_NPS, String(this.finishNps))
          }
        } catch (e) {}
      }
    },
    toTop() {
      // document.querySelector('.product-module').scrollIntoView({ behavior: 'smooth', block: 'start' })
      scrollY(0, {
        duration: 200
      })
      this.$nextTick(() => {
        document.getElementById('product-info-title')?.focus()
      })
    }
  },
  watch: {
    showNps(val) {
      if (val) {
        window.addEventListener('message', this.onMessage)
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
